import React, { useContext } from "react"
import { Button, Div, Text } from "atomize"
import Card from "../Card"
import { theme } from "../settings/config"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
	faEuroSign,
	faMoneyBill,
	faCreditCard,
	faMobileScreen,
	faUniversity,
	faReceipt,
	faCircleExclamation,
	faChevronRight,
} from "@fortawesome/free-solid-svg-icons"
import { modalContext } from "../providers/modal.provider"

const paymentIcon = method => {
	if (method === "cash") return faMoneyBill
	if (method === "pos") return faCreditCard
	if (method === "satispay") return faMobileScreen
	if (method === "bank_transfer") return faUniversity
	return faReceipt
}

const PaymentsCard = ({
	lessonsPaymentAmountByMethod,
	getPaymentMethod,
	lessonsWithoutPaymentMethod,
	summaryDate,
}) => {
	const Modal = useContext(modalContext)
	const missingCount = lessonsWithoutPaymentMethod?.length ?? 0

	const total = lessonsPaymentAmountByMethod
		? Object.values(lessonsPaymentAmountByMethod).reduce((s, v) => s + v, 0)
		: 0

	const hasPayments = total > 0

	return (
		<Card bg={theme.colors.surface}>
			<Div d="flex" align="center" justify="space-between" m={{ b: "1rem" }}>
				<Div d="flex" align="center" style={{ gap: "0.5rem" }}>
					<Div
						w="40px"
						h="40px"
						rounded="circle"
						bg={theme.colors.green_light}
						d="flex"
						align="center"
						justify="center">
						<FontAwesomeIcon icon={faEuroSign} color={theme.colors.green} />
					</Div>
					<Text textWeight="bold" textSize="title">
						Pagamenti
					</Text>
				</Div>
				{hasPayments && (
					<Div
						p="0.25rem 0.75rem"
						rounded="circle"
						bg={theme.colors.green_light}
						d="flex"
						align="center">
						<Text textWeight="bold" textColor={theme.colors.green} textSize="subheader">
							{total} €
						</Text>
					</Div>
				)}
			</Div>

			{/* Da dove viene il "Non specificato": le lezioni in cui qualcuno
			    non ha scritto come paga, da aprire e sistemare una per una. */}
			{missingCount > 0 && (
				<Button
					w="100%"
					h="auto"
					d="flex"
					align="center"
					justify="space-between"
					p="0.6rem 0.75rem"
					m={{ b: "0.75rem" }}
					rounded="15px"
					bg={theme.colors.red_light}
					style={{ gap: "0.5rem", textAlign: "left" }}
					onClick={() =>
						Modal.open("missingPaymentMethod", {
							lessons: lessonsWithoutPaymentMethod,
							summaryDate,
						})
					}>
					<Div d="flex" align="center" style={{ gap: "0.5rem" }}>
						<FontAwesomeIcon icon={faCircleExclamation} color={theme.colors.red} />
						<Text textSize="subheader" textColor={theme.colors.red}>
							{missingCount === 1
								? "1 lezione senza metodo di pagamento"
								: `${missingCount} lezioni senza metodo di pagamento`}
						</Text>
					</Div>
					<FontAwesomeIcon icon={faChevronRight} color={theme.colors.red} size="sm" />
				</Button>
			)}

			{hasPayments ? (
				<>
					{Object.keys(lessonsPaymentAmountByMethod)
						.filter(m => lessonsPaymentAmountByMethod[m] > 0)
						.map(method => (
							<Div
								key={method}
								d="flex"
								align="center"
								justify="space-between"
								p={{ y: "0.4rem" }}
								border="bottom"
								borderColor={theme.colors.gray_light}>
								<Div d="flex" align="center" style={{ gap: "0.5rem" }}>
									<FontAwesomeIcon
										icon={paymentIcon(method)}
										color={theme.colors.text_light}
										size="sm"
									/>
									<Text textSize="subheader">
										{getPaymentMethod(method)?.paymentName ?? "Non specificato"}
									</Text>
								</Div>
								<Text textSize="subheader" textWeight="bold">
									{lessonsPaymentAmountByMethod[method]} €
								</Text>
							</Div>
						))}
				</>
			) : (
				<Text textSize="subheader" textColor={theme.colors.text_light}>
					Nessun pagamento effettuato!
				</Text>
			)}
		</Card>
	)
}

export default PaymentsCard
